// @flow

import React from 'react';
import CheckboxField from './checkbox';

type ACFProps = {
  field_key: string,
  name: string,
  field_options: {
    blank: string,
    label: string,
  },
  options: Array<{|
    label: string,
    value: string,
  |}>,
  required: string,
};

export default ({
  field_key,
  field_options,
  name,
  options,
  required,
}: ACFProps) => (
  <CheckboxField
    showLabel={field_options.label === 'left'}
    label={name}
    name={field_key}
    options={options}
    required={required === '1'}
    requiredError={field_options.blank}
  />
);
